import { useFieldArray } from 'react-hook-form';
import { Button, Heading, Paragraph, Textfield } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useSolcelleFormContext } from '../utils';

import { InfoPopover } from './infoPopover';
import { PanelCard, PanelRowWrapper, PanelWrapper, RemoveButtonWrapper } from './styledComponents';
import { useSolcellerValidation } from './useSolcellerValidation';
import { RemoveButton } from './removeButton';

export const KwpPanels = () => {
  const { t } = useTranslation();
  const { validateAzimuth, validateTilt, validateKwp, decimalPattern, integerPattern } = useSolcellerValidation();
  const { control, register, formState } = useSolcelleFormContext();
  const { fields, append, remove } = useFieldArray({ name: 'kwpPanels', control });
  const { errors } = formState;

  return (
    <PanelWrapper>
      <div>
        <Heading data-size="xs" level={3}>
          {t('register.solar.form.placement.label')}
        </Heading>
        <Paragraph>{t('register.solar.form.placement.info')}</Paragraph>
      </div>
      <InfoPopover />
      {fields.map((field, index) => (
        <PanelCard key={field.id}>
          <PanelRowWrapper>
            <Textfield
              type="text"
              inputMode="numeric"
              label={t('register.solar.form.panel.azimuth')}
              suffix={t('register.solar.form.suffix.grader')}
              error={errors.kwpPanels?.[index]?.azimuth?.message}
              {...register(`kwpPanels.${index}.azimuth`, {
                validate: validateAzimuth,
                pattern: integerPattern
              })}
            />
            <Textfield
              type="text"
              inputMode="numeric"
              suffix={t('register.solar.form.suffix.grader')}
              label={t('register.solar.form.panel.tilt')}
              error={errors.kwpPanels?.[index]?.tilt?.message}
              {...register(`kwpPanels.${index}.tilt`, {
                validate: validateTilt,
                pattern: integerPattern
              })}
            />
            <Textfield
              type="text"
              inputMode="decimal"
              suffix={t('register.solar.form.suffix.kwp')}
              label={t('register.solar.form.panel.effect')}
              error={errors.kwpPanels?.[index]?.effect?.message}
              {...register(`kwpPanels.${index}.effect`, {
                pattern: decimalPattern,
                validate: validateKwp
              })}
            />
          </PanelRowWrapper>
          {index > 0 && (
            <RemoveButtonWrapper>
              <RemoveButton onClick={() => remove(index)} />
            </RemoveButtonWrapper>
          )}
        </PanelCard>
      ))}
      <div>
        <Button variant={'secondary'} onClick={() => append({})}>
          {t('register.solar.form.buttons.add')}
        </Button>
      </div>
    </PanelWrapper>
  );
};
